import { render, staticRenderFns } from "./sales-tracker-card.vue?vue&type=template&id=1fa856e9"
import script from "./sales-tracker-card.vue?vue&type=script&lang=js"
export * from "./sales-tracker-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports